import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { isEmpty } from 'lodash';

import { SIGNUP_PATHS } from '../../../constants';
import IconBtn from '../../../modules/icon-btn/icon-btn';
import { LoginData } from '../../../services/api/dto/Auth';
import { useAppDispatch } from '../../../store';
import { getLoginId, login } from '../../../store/actions/auth';
import { getCompanyInfo } from '../../../store/actions/company-info';

import ConfirmationCodeBody from './confirmation-code-body';
import UsernamePasswordBody from './username-password-body';

import './login-form.scss';

const MIN_PASSWORD_LENGHT = 8;

const Login: React.FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [phoneNumber, setPhonenumber] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [isError, setError] = useState(false);
  const [credentials, setLoginCredentials] = useState({} as LoginData);
  const [isLoading, setIsLoading] = useState(false);

  const submitPassword = () => {
    if (phoneNumber && password) {
      setIsLoading(true);
      dispatch(
        getLoginId({
          phoneNumber,
          password,
          callback: (data) => {
            setIsLoading(false);
            setLoginCredentials(data);
          },
          errorCallback: () => {
            setIsLoading(false);
            setError(true);
          },
        })
      );
    }
  };

  const submitCode = (verificationCode?: string) => {
    setIsLoading(true);
    let loginSuccess = false;
    const callback = () => {
      loginSuccess = true;
      dispatch(getCompanyInfo()).then((res) => {
        let payload = res.payload as {
          status: 'VERIFIED' | 'NON_VERIFIED' | 'NEED_KEY_GENERATION';
        };
        setIsLoading(false);
        if (payload.status === 'VERIFIED') {
          history.push('/');
        } else if (payload.status === 'NEED_KEY_GENERATION') {
          history.push(SIGNUP_PATHS.KEY_GENERATION);
        } else {
          history.push(SIGNUP_PATHS.VERIFICATION);
        }
      });
    };
    dispatch(login({ code: verificationCode || code, credentials, callback })).finally(() => {
      if (!loginSuccess) {
        setIsLoading(false);
      }
    });
  };

  const isButtonDisabled = () => {
    const isDataValid =
      phoneNumber && password && password.length >= MIN_PASSWORD_LENGHT;

    return (
      (isEmpty(credentials) && !isDataValid) || (!isEmpty(credentials) && !code)
    );
  };

  return (
    <form className="login-form login-form--7">
      <div className="login-form__header">
        <h1 className="title-3 login-form__title-big">Вход</h1>
        <h2 className="login-form__title">Введите номер телефона и пароль</h2>
      </div>
      {isEmpty(credentials) ? (
        <UsernamePasswordBody
          setPhonenumber={setPhonenumber}
          setPassword={setPassword}
          isError={isError}
          setError={setError}
          phoneNumber={phoneNumber}
          submitPassword={submitPassword}
        />
      ) : (
        <ConfirmationCodeBody
          onInputFill={(value) => {
            setCode(value);
            submitCode(value);
          }}
          requestResend={submitPassword}
        />
      )}
      <div className="login-form__footer">
        <div className="login-form__actions">
          <IconBtn
            lg
            title="Войти"
            onClick={isEmpty(credentials) ? submitPassword : submitCode}
            disabled={isButtonDisabled() || isLoading}
            loading={isLoading}
          />
          <Link to={SIGNUP_PATHS.BASE}>Зарегистрироваться</Link>
        </div>
      </div>
    </form>
  );
};

export default Login;
